
/**
 * Check if the current environment is a development environment.
 * @returns {boolean}
 */
export function isDevEnvironment() {
  const hostname = window.location.hostname;
  return hostname.includes("local") || hostname.includes("staging") || hostname.includes("qa");
}


/**
 * Predictable pseudo-random number generator.
 * @param {*} inputString
 * @param {number} n
 * @returns number in [0,n]
 */
export function pseudoRandom(inputString, n) {
  let hash = 0;
  for (let i = 0; i < inputString.length; i++) {
    hash = (hash << 5) - hash + inputString.charCodeAt(i);
    hash |= 0; // Convert to 32-bit integer
  }
  // Normalize the hash to
  return Math.round(Math.abs(hash)) % n;
}

/**
 * Pad a number to 2 digits, e.g. 1 -> "01", 12 -> "12". Useful for dates and times.
 * @param {number|string} n
 * @returns {string}
 */
export function oh(n) {
  return n.toString().padStart(2, "0");
}

export function pseudoRandomDate(name) {
  try {
    let ds = "2025-01-23T" + oh(9 + pseudoRandom(name, 7)) + ":" + oh(pseudoRandom(name, 59));
    return new Date(ds);
  } catch (e) {
    console.error(e);
    return new Date();
  }
}